// extracted by mini-css-extract-plugin
export default {"cont1":"Sidebar_cont1__uQNPp","listText":"Sidebar_listText__fE1Zg","svgCont":"Sidebar_svgCont__LFZrT","textContainer":"Sidebar_textContainer__nYEV5","cont2":"Sidebar_cont2__8Eqiq"};